<div class="p-6 space-y-4">
  @if (error) {
    <div class="p-3 bg-error-50 dark:bg-error-500/10 border border-error-200 dark:border-error-500/20 rounded-lg text-sm text-error-700 dark:text-error-400">
      {{ error }}
    </div>
  }

  @if (isSystem) {
    <div class="p-3 bg-blue-50 dark:bg-blue-500/10 border border-blue-200 dark:border-blue-500/20 rounded-lg text-xs text-blue-700 dark:text-blue-400">
      Este es un estado del sistema. El nombre interno y los indicadores de comportamiento (Default/Resuelto/Terminal) no son editables, pero puedes cambiar el label visible, color y orden.
    </div>
  }

  <form [formGroup]="form" (ngSubmit)="guardar()" class="space-y-4">
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Nombre interno <span class="text-error-500">*</span>
      </label>
      <input type="text" formControlName="name" placeholder="WAITING_VENDOR"
        maxlength="50"
        class="w-full px-2.5 py-1.5 text-sm border rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 font-mono uppercase disabled:opacity-60 disabled:cursor-not-allowed"
        [class.border-error-500]="hasError('name')"
        [class.border-gray-300]="!hasError('name')" />
    </div>

    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Label visible <span class="text-error-500">*</span>
      </label>
      <input type="text" formControlName="label" placeholder="En espera (proveedor)"
        maxlength="100"
        class="w-full px-2.5 py-1.5 text-sm border rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500"
        [class.border-error-500]="hasError('label')"
        [class.border-gray-300]="!hasError('label')" />
    </div>

    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Color</label>
      <div class="flex items-center gap-2">
        <input type="color" formControlName="color"
          class="h-10 w-12 cursor-pointer rounded border border-gray-300 dark:border-gray-600" />
        <input type="text" formControlName="color"
          class="flex-1 px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white font-mono" />
      </div>
    </div>

    <div class="space-y-2">
      <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
        <input type="checkbox" formControlName="isDefault" class="rounded border-gray-300 dark:border-gray-600 disabled:opacity-60 disabled:cursor-not-allowed" />
        Default (NEW para tickets nuevos)
      </label>
      <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
        <input type="checkbox" formControlName="isResolved" class="rounded border-gray-300 dark:border-gray-600 disabled:opacity-60 disabled:cursor-not-allowed" />
        Resuelto (cuenta como resuelto en métricas)
      </label>
      <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
        <input type="checkbox" formControlName="isTerminal" class="rounded border-gray-300 dark:border-gray-600 disabled:opacity-60 disabled:cursor-not-allowed" />
        Terminal (no permite siguientes transiciones)
      </label>
      <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
        <input type="checkbox" formControlName="isActive" class="rounded border-gray-300 dark:border-gray-600" />
        Activo
      </label>
    </div>

    <div class="flex justify-end gap-2 pt-3 border-t border-gray-200 dark:border-gray-700">
      <app-button variant="outline" type="button" (btnClick)="cancelar()">Cancelar</app-button>
      <app-button type="button" [disabled]="saving" (btnClick)="guardar()">
        @if (saving) { Guardando… } @else { {{ isEditing ? 'Actualizar' : 'Guardar' }} }
      </app-button>
    </div>
  </form>
</div>